import { render, staticRenderFns } from "./FormuleAptamil.vue?vue&type=template&id=7305ddd8&"
import script from "./FormuleAptamil.vue?vue&type=script&lang=js&"
export * from "./FormuleAptamil.vue?vue&type=script&lang=js&"
import style0 from "./FormuleAptamil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports